
const Main = resolve=> require(['@/oms/main.vue'],resolve);
const Home = resolve=> require(['@/oms/home.vue'],resolve);
const FBA = resolve=> require(['@/oms/home.vue'],resolve);

const orderImport = resolve=> require(['@/oms/order/orderimport.vue'],resolve);
const orderVIPImport = resolve=> require(['@/oms/order/orderimportvip.vue'],resolve);
const clearanceImport = resolve=> require(['@/oms/order/clearanceImport.vue'],resolve);


const singleEntry = resolve=> require(['@/oms/order/singleentryadd.vue'],resolve);
const ModifySingleEntry = resolve=> require(['@/oms/order/singleentrymodify.vue'],resolve);
const BrowseSingleEntry = resolve=> require(['@/oms/order/singleentrybrowse.vue'],resolve);
const ConsolidationBillManagementOMS = resolve=> require(['@/oms/consolidation/consolidationBillManagement.vue'],resolve);

const TimelinessReport = resolve=> require(['@/oms/report/timelinessReport.vue'],resolve);
const TimelinessReportDetail = resolve=> require(['@/oms/report/timelinessReportDetail.vue'],resolve);



const orderPrediction = resolve=> require(['@/oms/order/orderprediction.vue'],resolve);
const orderModify = resolve=> require(['@/oms/order/ordermodify.vue'],resolve);
const orderRead = resolve=> require(['@/oms/order/orderread.vue'],resolve);
const Problem = resolve=> require(['@/oms/customer/problem/problem.vue'],resolve);
const ProblemReply = resolve=> require(['@/oms/customer/problem/problemreply.vue'],resolve);
const TrackQuery = resolve=> require(['@/oms/customer/trackquery.vue'],resolve);
const OmsManifestQuery = resolve=> require(['@/oms/customer/manifestquery.vue'],resolve);
// const DeliveryRecord = resolve=> require(['@/oms/customer/deliveryrecord.vue'],resolve);
const omsPrint = resolve=> require(['@/utils/agenttoplaysingle.vue'],resolve);
const FrameHtml = resolve=> require(['@/utils/framehtml.vue'],resolve);
const QuotationInquiry = resolve=> require(['@/oms/finance/quotation_inquiry.vue'],resolve);
const CustbalanceQuery = resolve=> require(['@/oms/finance/custbalance_query.vue'],resolve);
const custbalanceChange = resolve=> require(['@/oms/finance/custbalance_change.vue'],resolve);

const RemoteFee = resolve=> require(['@/oms/finance/remotefee.vue'],resolve);
const BillmanageOms = resolve=> require(['@/oms/finance/billmanage/billmanagement_oms.vue'],resolve);

const BillmanagementDetailOms = resolve=> require(['@/oms/finance/billmanage/billmanagementdetail_oms.vue'],resolve);

const BillmanageOmsDetail = resolve=> require(['@/oms/finance/billmanage/billmanagement_oms_detail.vue'],resolve);
const BillmanageOmsDaiDetail = resolve=> require(['@/oms/finance/billmanage/billmanagement_oms_dai_detail.vue'],resolve);
const ManifestRead = resolve=> require(['@/oms/customer/manifestread.vue'],resolve);
const PrintQuery = resolve=> require(['@/oms/printquery/printquery.vue'],resolve);
const ScanPrint = resolve=> require(['@/oms/scanPrint/scanPrint.vue'],resolve);

const CarTask = resolve=> require(['@/oms/cartask/cartask.vue'],resolve);
//cmn
const OmsMag = resolve => require(['@/oms/cmn/msgMag.vue'],resolve);

const Authorization = resolve => require(['@/oms/authorization/authorization.vue'],resolve);
const ApiAuth = resolve => require(['@/oms/authorization/apiauth.vue'],resolve);
const Downloadthelog = resolve => require(['@/oms/authorization/downloadthelog.vue'],resolve);

const OrderManage = resolve=> require(['@/oms/order/ordermanage.vue'],resolve);
const OrderManageModify = resolve=> require(['@/oms/order/ordermanageimport.vue'],resolve);
const Upgrade = resolve=> require(['@/oms/order/Upgrade.vue'],resolve);
const Fees = resolve => require(['@/oms/finance/fees.vue'], resolve);
const routers = [
    {path : "/",name: 'Main',component: Main,redirect: {name: 'Home'},
        children:[
            {path: '/home',name: 'Home',component: Home,meta: {tabName: 'home'}},
            {path: '/fba',name: 'FBA',component: FBA,meta: {tabName: 'FBA'}},
            //订单导入
            {path: '/order/orderimport', name: 'orderImport', component: orderImport, meta: { tabName: 'OMS003'}},
            {path: '/order/clearanceImport', name: 'clearanceImport', component: clearanceImport, meta: { tabName: 'OMS045'}},

            //批量导入
            {path: '/order/vip/orderimport', name: 'orderVIPImport', component: orderVIPImport, meta: { tabName: 'OMSImport'}},

            {path: '/order/singleentry', name: 'singleEntry', component: singleEntry, meta: { tabName: 'OMS002'}},
            {path: '/order/modify/singleentry', name: 'ModifySingleEntry', component: ModifySingleEntry, meta: { tabName: 'OMS0021'}},
            {path: '/order/browse/singleentry', name: 'BrowseSingleEntry', component: BrowseSingleEntry, meta: { tabName: 'OMS0022'}},
            {path: '/consolidation/consolidationBillManagementOMS', name: 'ConsolidationBillManagementOMS', component: ConsolidationBillManagementOMS, meta: { tabName: 'OMS043'}},
            
            {path: '/report/timelinessReport', name: 'TimelinessReport', component: TimelinessReport, meta: { tabName: 'OMS044'}},
            {path: '/report/timelinessReportDetail', name: 'TimelinessReportDetail', component: TimelinessReportDetail, meta: { tabName: 'OMS0441'}},
            
            
            //订单预报
            {path: '/order/orderprediction', name: 'orderPrediction', component: orderPrediction, meta: { tabName: 'OMS004'}},
            {path: '/order/ordermodify/:id', name: 'orderModify', component: orderModify, meta: { tabName: 'OMS0041'}},
            {path: '/order/orderread/:id', name: 'orderRead', component: orderRead, meta: { tabName: 'OMS0042'}},
            //问题件
            {path: '/problem/problem', name: 'Problem', component: Problem, meta: { tabName: 'OMS008'}},
            {path: '/problem/problemreply', name: 'ProblemReply', component: ProblemReply, meta: { tabName: 'OMS0081'}},
            {path: '/customer/trackquery', name: 'TrackQuery', component: TrackQuery, meta: { tabName: 'trackquery'}},
            {path: '/customer/manifestquery', name: 'OmsManifestQuery', component: OmsManifestQuery, meta: { tabName: 'OMS007'}},
            {path: '/customer/manifestread/:id', name: 'ManifestRead', component: ManifestRead, meta: { tabName: 'OMS0071'}},
            {path: '/order/omsPrint', name: 'omsPrint', component: omsPrint, meta: { tabName: 'OMS005'}},
            {path: '/framehtml/framehtml',name: 'FrameHtml',component:  FrameHtml,meta: {tabName: 'frameHtml'}},
            {path: '/printquery/printquery',name: 'PrintQuery',component:  PrintQuery,meta: {tabName: 'OMS006'}},
            {path: '/scanprint/scanprint',name: 'scanPrint',component:  ScanPrint,meta: {tabName: 'OMS015'}},
            // 发货记录
            // {path: '/customer/deliveryrecord', name: 'DeliveryRecord', component: DeliveryRecord, meta: { tabName: 'deliveryrecord'}},

            //vip 订单管理
            {path: '/order/ordermanage', name: 'OrderManage', component: OrderManage, meta: { tabName: 'OMS018'}},
            {path: '/order/ordermanage/modify', name: 'OrderManageModify', component: OrderManageModify, meta: { tabName: 'OMS0181'}},
            //财务
            //报价查询
            {path: '/finance/quotationinquiry', name: 'QuotationInquiry', component: QuotationInquiry, meta: { tabName: 'OMS009'}},
            //偏远查询
            {path: '/finance/remotefee', name: 'RemoteFee', component: RemoteFee, meta: { tabName: 'OMS010'}},
            //账单管理
            {path: '/finance/billmanageoms', name: 'BillmanageOms', component: BillmanageOms, meta: { tabName: 'OMS012'}},
            {path: '/finance/billmanageomsdetail/:param1/:param2', name: 'BillmanageOmsDetail', component: BillmanageOmsDetail, meta: { tabName: 'OMS0121'}},
            {path: '/finance/billmanageomsdaidetail/:param1/:param2', name: 'BillmanageOmsDaiDetail', component: BillmanageOmsDaiDetail, meta: { tabName: 'OMS0122'}},

            {path: '/billmanagement/detail', name: 'BillmanagementDetailOms', component: BillmanagementDetailOms, meta: { tabName: 'OMS016'}},

            //余额查询
            {path: '/finance/custbalance', name: 'CustbalanceQuery', component: CustbalanceQuery, meta: { tabName: 'OMS011'}},
            {path: '/finance/custbalance_change/:param1/:param2/:param3',name: 'custbalanceChange',component:  custbalanceChange,meta: {tabName: 'OMS0111'}},

            //cmn
            {path: '/oms/msgmag',name: 'OmsMag',component: OmsMag,meta: {tabName: 'CMN002'}},

            {path: '/authorization/authorization',name: 'Authorization',component: Authorization,meta: {tabName: 'authorization'}},
            {path: '/apiauth/apiauth',name: 'ApiAuth',component: ApiAuth,meta: {tabName: 'apiauth'}},
            {path: '/authorization/downloadthelog',name: 'Downloadthelog',component: Downloadthelog,meta: {tabName: 'downloadthelog'}},

            //取件申请
            {path: '/oms/cartask', name: 'CarTask', component: CarTask, meta: { tabName: 'OMS017'}},
            // 升级B端客户
            {path: '/oms/UpgradeBendCustomers', name: 'Upgrade', component: Upgrade, meta: { tabName: 'OMS050'}},
            // 预扣费明细
            {path: '/oms/fees', name: 'Fees', component: Fees, meta: { tabName: 'OMS022001'}},
        ]
    }

];

const omsRouter = {};

omsRouter.getRouters = function () {
    return routers;
};


export default omsRouter;







// WEBPACK FOOTER //
// /home/jenkins/.jenkins/workspace/tms-saas/code/tms-front/test/tms-front/src/router/omsRouter.js